import styled from 'styled-components';
import { SkeletonLine } from './skeletonLine';

const OptionColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
`;

/** Mirrors the bordered box that antd radio and checkbox rows render in. */
const OptionRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  border: 1px solid var(--clr-border-grey-100);
  border-radius: 5px;
  padding: 9px 10px;
  min-height: 38px;
  background-color: var(--clr-container-bg);
`;

/** Cycled so the rows do not read as one uniform block. */
const LABEL_WIDTHS = ['62%', '48%', '71%', '55%'];

interface SkeletonOptionListProperties {
  count?: number;
  withControl?: boolean;
}

const SkeletonOptionList = ({ count = 6, withControl = true }: SkeletonOptionListProperties) => (
  <OptionColumn data-testid="skeleton-option-list">
    {Array.from({ length: count }, (_, index) => (
      <OptionRow key={`skeleton-option-${index}`}>
        <SkeletonLine $width={LABEL_WIDTHS[index % LABEL_WIDTHS.length]} $height="14px" />
        {withControl && <SkeletonLine $width="16px" $height="16px" $radius="50%" />}
      </OptionRow>
    ))}
  </OptionColumn>
);

export default SkeletonOptionList;
